import React from 'react';

export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) { return { error }; }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          minHeight: '100vh', background: 'var(--navy)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontFamily: 'Inter, sans-serif', padding: 24,
        }}>
          <div style={{ textAlign: 'center', maxWidth: 400 }}>
            <div style={{ fontSize: 56, marginBottom: 16 }}>⚡</div>
            <h2 style={{ fontSize: 20, fontWeight: 700, color: 'var(--text-1)', marginBottom: 8 }}>
              Something went wrong
            </h2>
            <p style={{ color: 'var(--text-3)', fontSize: 14, marginBottom: 24 }}>
              An unexpected error occurred. This has been noted.
            </p>
            <button
              onClick={() => { this.setState({ error: null }); window.location.href = '/'; }}
              style={{
                padding: '10px 24px', borderRadius: 10, border: 'none',
                background: 'var(--teal)', color: 'var(--navy)',
                fontWeight: 700, fontSize: 14, cursor: 'pointer',
              }}
            >
              Back to Map
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
